import { render, staticRenderFns } from "./card-payouts.vue?vue&type=template&id=34c681a8&scoped=true&"
import script from "./card-payouts.vue?vue&type=script&lang=js&"
export * from "./card-payouts.vue?vue&type=script&lang=js&"
import style0 from "./card-payouts.vue?vue&type=style&index=0&id=34c681a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c681a8",
  null
  
)

export default component.exports